import { ChatSubscription } from "../models/app/ChatSubscription";
import { IMChat } from "../models/api/IMChat";
import { MqttBroadcast } from "../models/app/MqttBroadcast";
import { appConfig } from "../models/constants";
import { rootStore } from "../StApp";
import { db } from "./DexieDbImpl";
import MqttService from "./MqttService";
import NotificationHandlerService from "./NotificationHandlerService";
import { IMChatType } from "../models/api/IMChatType";

abstract class IMChatSubscriptionServiceBase {

    abstract subscribeToChat(chatId: string, handler: ChatSubscription): void

    abstract unsubscribe(chatId: string): void

    abstract handleMsg(msg: IMChat): void
}

export class IMChatSubscriptionService extends IMChatSubscriptionServiceBase {

    subscriptions = new Map<string, ChatSubscription>()
    testText = 1

    private static _instance: IMChatSubscriptionService;

    private constructor() {
        super()
    }

    public static get Instance() {
        // Do you need arguments? Make it a regular static method instead.
        return this._instance || (this._instance = new this());
    }

    subscribeToChat(chatId: string, handler: ChatSubscription): void {
        this.subscriptions = this.subscriptions.set(chatId, handler)
        this.makeMqttSubscriptionForStatus(chatId)
        console.log('Subscribed chat')

    }

    unsubscribe(chatId: string): void {
        this.subscriptions.delete(chatId)
        this.unsubscribeFromStatus(chatId)
        this.testText++
    }

    handleMsg(msg: IMChat) {
        this.execMsgHandler(msg)

        //Insert into db
        db.putChatMsg(msg)

    }

    handleStatusUpdate(status: MqttBroadcast) {
        this.execStatusHandler(status)
    }

    private execMsgHandler(msg: IMChat) {
        const callBack = this.subscriptions.get(msg.senderUid)?.chatMsgHandler
        if (callBack)
            callBack(msg)
        // Chat head is upserted here instead of in handleMsg prev to mark unread flag
        if(msg.imChatType == IMChatType.BLOCK_USER)
         return
         
        db.createChat({
            chatterId: msg.senderId,
            chatterUid: msg.senderUid,
            lastMsg: msg,
            lastMsgTime: msg.timestamp,
            convStartTime: msg.convStartTime,
            unread: callBack? false: true
        })

        NotificationHandlerService.handleImChat(msg)
    }

    private execStatusHandler(status: MqttBroadcast) {
        const callBack = this.subscriptions.get(status.postByUid)?.statusHandler
        if (callBack)
            callBack(status.msg)
    }

    private makeMqttSubscriptionForStatus(uid: string) {
        const topic = `${appConfig.MQTT_BASE}/${appConfig.MQTT_PUBLIC}/${uid}/${appConfig.MQTT_STATUS}`
        MqttService.subscribe(topic)
    }

    private unsubscribeFromStatus(uid: string) {
        const topic = `${appConfig.MQTT_BASE}/${appConfig.MQTT_PUBLIC}/${uid}/${appConfig.MQTT_STATUS}`
        MqttService.unsubscribe(topic)
    }


}

// export default IMChatSubscriptionService.Instance